import { useSyncExternalStore } from "react";

export type Theme = "light" | "dark";

/** Also read by the inline script in index.html, which applies the choice before first paint. */
const STORAGE_KEY = "gillspotter-theme";
const PAPER: Record<Theme, string> = { light: "#f2f2ee", dark: "#0d0d0c" };
const listeners = new Set<() => void>();

function current(): Theme {
  return document.documentElement.dataset.theme === "dark" ? "dark" : "light";
}

function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", PAPER[theme]);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Storage disabled: the choice lasts for this visit only.
  }
  listeners.forEach((notify) => notify());
}

function subscribe(notify: () => void): () => void {
  listeners.add(notify);
  return () => listeners.delete(notify);
}

const serverTheme = (): Theme => "light";

/** Light first; an explicit choice persists per browser. */
export function useTheme(): [Theme, (theme: Theme) => void] {
  const theme = useSyncExternalStore(subscribe, current, serverTheme);
  return [theme, applyTheme];
}
